<template>
  <accordion-panel
    id="final-temperature-charts"
    class="final-temperature-section__accordion avoid-break"
    :collapsed.sync="collapsed"
  >
    <template #title>
      <strong>{{
        $t('engineering.final-gradient.expected-final-temperature-x-time')
      }}</strong>
    </template>
    <b-row
      v-show="loading"
      class="my-5"
    >
      <b-col
        class="text-center"
        cols="12"
      >
        <s-loader size="lg" />
      </b-col>
    </b-row>
    <div v-show="showContent">
      <b-row
        class="final-temperature-section__subtitle-wrapper mb-2"
        align-h="between"
      >
        <b-col
          class="final-temperature-section__subtitle-content"
          v-for="(subtitle, index) in subtitles"
          cols="auto"
          :key="index"
        >
          <div class="d-inline-block">
            <i
              class="final-temperature-section__subtitle fas fa-square-full mr-2"
              aria-hidden="true"
              :class="subtitle.class"
            ></i> {{ $t(`engineering.final-gradient.${subtitle.text}`) }}
          </div>
        </b-col>
      </b-row>
      <b-row class="final-temperature-section__chart-wrapper">
        <b-col
          class="final-temperature-section__chart"
          v-for="windingId in windingAmount"
          cols="auto"
          :xl="colsByWindings"
          :key="(windingId)"
        >
          <final-temperature-chart
            class="final-temperature-section__chart-item"
            :chart-data="getChartData(windingId - 1)"
            :winding-id="(windingId)"
            :show-title="showFinalTemperatureTitle"
            :is-collapsed="collapsed"
          />
        </b-col>
      </b-row>
    </div>
    <s-empty-list v-show="showEmptyList" />
  </accordion-panel>
</template>

<script>
import AccordionPanel from '@/components/AccordionPanel';
import FinalTemperatureChart
  from '@/domain/components/installation/engineering/finalGradient/FinalTemperatureChart';

export default {
  name: 'FinalTemperatureSection',
  components: {
    AccordionPanel,
    FinalTemperatureChart,
  },
  props: {
    finalTemperatureCharts: {
      type: Array,
      default: () => ([]),
    },
    windingAmount: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    collapsed: false,
  }),
  computed: {
    showFinalTemperatureTitle() {
      return this.finalTemperatureCharts.length > 1;
    },
    showContent() {
      return !this.loading && (this.finalTemperatureCharts || []).length;
    },
    showEmptyList() {
      return !this.loading && !(this.finalTemperatureCharts || []).length;
    },
    colsByWindings() {
      const maxColumns = 12;
      if (!this.windingAmount) return maxColumns;
      return maxColumns / this.windingAmount;
    },
    subtitles() {
      return [
        {
          class: 'final-temperature-section__subtitle--gray',
          text: 'transformer-oil',
        },
        {
          class: 'final-temperature-section__subtitle--primary',
          text: 'winding-degrees',
        },
        {
          class: 'final-temperature-section__subtitle--blue',
          text: 'final-winding-degrees',
        },
        {
          class: 'final-temperature-section__subtitle--orange',
          text: 'alarm',
        },
        {
          class: 'final-temperature-section__subtitle--danger',
          text: 'shutdown',
        },
      ];
    },
  },
  methods: {
    getChartData(index) {
      return this.finalTemperatureCharts[index] || {};
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"

.final-temperature-section
  &__accordion
    border: 1px solid $color-border-gray
    border-radius: 5px
  &__chart-item
    min-width: 200px
    margin: 5px 0
  &__chart
    display: inline-flex
    flex-direction: column
    flex: 1
  &__subtitle
    &--primary
      color: var(--color-primary)
      font-size: 1.1em
    &--danger
      color: var(--color-danger)
      font-size: 1.1em
      opacity: .5
    &--orange
      color: var(--color-secondary)
      font-size: 1.1em
      opacity: .5
    &--blue
      color: var(--chart-color-blue)
      font-size: 1.1em
    &--gray
      color: var(--chart-color-gray)
      font-size: 1.1em
::v-deep
  .accordion-panel
    &__header
      padding: 2px 15px !important
      font-weight: bold

@media screen
  +media-max-lg()
    .final-temperature-section
      &__subtitle-wrapper
        flex-direction: column

@media print
  .final-temperature-section
    &__subtitle-wrapper
      justify-content: flex-start !important
</style>
